import React, { useCallback } from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { Select, Typography, SelectProps, MenuItem } from '@material-ui/core';
import { stylesConstants } from '../../styles/stylesConstants';

const CustomSelect: React.FC<IEditForm> = ({
  onChange,
  value,
  fieldName,
  label,
  variants,
  fullWidth,
  multiple = false,
  disabled = false,
}) => {
  const handleOnChange: SelectProps['onChange'] = useCallback(
    (event) => {
      return onChange ? onChange(fieldName, event.target.value) : () => null;
    },
    [fieldName, onChange],
  );

  return (
    <>
      <Typography variant="body2">{label}</Typography>
      <Select
        id={fieldName}
        name={fieldName}
        onChange={handleOnChange}
        value={value || ''}
        style={{ width: fullWidth ? '100%' : stylesConstants.inputFormWidth }}
        multiple={multiple}
        disabled={disabled}
      >
        {variants?.map((variant) => (
          <MenuItem key={variant.value} value={variant.value}>
            {variant.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default CustomSelect;
